import { format, parseISO } from 'date-fns'
import type { ReferralSteeragePersonListResponse } from '@fireflyhealth/api'
import { SteerageProviderStatus } from '~/entities/steerage'

export type SteerageItem = ReferralSteeragePersonListResponse[number]
export type SteerageProviderItem = SteerageItem['steerage_providers'][number]

/**
 * If this Steerage has a Referral, this is the Elation created date; if it
 * only has a Waiver, the waiver's created date.
 */
export const getCreatedDate = (steerage: SteerageItem) => {
  if (steerage?.has_referral && steerage?.referral?.vendor_create_date)
    return parseISO(steerage?.referral?.vendor_create_date)
  if (steerage?.has_waiver && steerage?.waiver?.created_at) {
    return parseISO(steerage?.waiver?.created_at)
  }
  return null
}

export const getFormattedCreatedDate = (steerage: SteerageItem) => {
  const createdDate = getCreatedDate(steerage)
  if (createdDate) return format(createdDate, 'MM/dd/yyyy')
  return ''
}

export const getFilteredSteerageProvider = (steerage: SteerageItem) => {
  const filteredSteerageProvider = steerage?.steerage_providers?.filter(
    provider => provider.status === SteerageProviderStatus.Accepted,
  )
  return filteredSteerageProvider ?? []
}

/**
 * The provider name shown in the Providers column: the member-selected
 * provider when one exists, otherwise the first provider; the facility name
 * wins over the person name in both cases.
 */
export const showProviderNameColumnData = (providers: Array<SteerageProviderItem>) => {
  const memberSelectedProvider = providers?.find(provider => provider?.member_selected_at != null)

  if (memberSelectedProvider) {
    return memberSelectedProvider?.care_organization_name
      ? memberSelectedProvider?.care_organization_name
      : memberSelectedProvider.first_name + ' ' + memberSelectedProvider.last_name
  }
  const provider = providers[0]
  return provider?.care_organization_name
    ? provider?.care_organization_name
    : provider?.first_name + ' ' + provider?.last_name
}

export const getSteerageType = (steerage: SteerageItem) => {
  if (steerage.is_effectively_referral_and_waiver) return 'Referral w/Care Key'
  if (steerage.is_effectively_referral_only) return 'Referral'
  if (steerage.is_effectively_waiver_only) return 'Care Key'
  return ''
}
